export class NursePractitioner {

    assignChanged: boolean;
    assignedClientNames: string;
    assignedProjectNames: string;
    assignedProjects: number[];
    additionalExams: any[];
    assignedBatches: any[];
    clientId: number;
    clientName: string;
    createdBy: string;
    displayMemberTypes: string;
    displayVisitTypes: string;
    id: number;
    maxCallLimit: number;
    memberTypes: any[];
    nursePractitioners: any[];
    projectDesc: string;
    projectEndDate: Date;
    projectId: number;
    projectName: string;
    projectStartDate: Date;
    updatedBy: string;
    visitTypes: any[];
    city: string;
    firstName: string;
    isAssigned: boolean;
    lastName: string;
    nursePractitionerId: number;
    phoneNumber: string;
    serviceAddress1: string;
    serviceAddress2: string;
    state: string;
    zip: string;
    clientIds: number[]=[];
    projectIds: number[]=[];
}

export class AssignNursePractitioner {
    clientIds: string[]=[];
    nursePractitionerId: number;
    projectIds: string[]=[];
    isAssigned: boolean;
    updatedBy: string;
}

// export class ProjectId {
//     projectIds: any[] = [];
// }

// export class ClientId {
//     clientIds: any[] = [];
// }
